module.exports={"Star Rating":"Tähtiluokitus","# star(s)":"{currentRating, plural, =1{# tähti} other{# tähteä}}"};